import gql from 'graphql-tag';
import client from '../lib/apolloClient';

const sendAnalyticsEvent = gql`
  mutation sendAnalyticsEvent($eventName: String!, $customProps: Json) {
    sendAnalyticsEvent(eventName: $eventName, customProps: $customProps)
  }
`;

// Analytics events are NOT client-side Ahoy calls. They round-trip through this
// mutation, which writes the Ahoy::Event server-side (mutation_type.rb:532).
// `customProps` is stringified here and parsed back by Types::JsonType
// (json_type.rb:3) before reaching ahoy.track, which is what makes
// `properties->>'viewed_user_id'` queryable by ViewedYourProfileWorker.
//
// Every failure here is swallowed by design — tracking must never break the
// interaction that triggered it. But swallowed is not the same as invisible:
// 'Profile View' was dead for seven weeks and nothing anywhere reported it,
// because the only signal was a console.log lost among ordinary log noise.
// console.error at least surfaces in error consoles and is picked up by browser
// error monitoring. There is no JS error reporter in this codebase today; if one
// is ever added, this is the call site that should report to it.
export const trackAnalyticsEvent = (name, customProps) => {
  client
    .mutate({
      variables: {
        eventName: name,
        customProps: JSON.stringify(customProps),
      },
      mutation: sendAnalyticsEvent,
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error(`[ANALYTICS] failed to record "${name}":`, error);
    });
};
